import axios from 'axios';
import config from '../../config';

const http = axios.create({
  baseURL: config.api.gravity,
  timeout: 5000,
});

export default {
  async getApplicationSettings() {
    try {
      const result = await http.get('v1/apps/lutrijabih_custom_admin/settings');
      return result.data.appSettings;
    } catch (e) {
      const error = e.response ? e.response.data : e;
      return {
        error: true,
        ...error,
      };
    }
  },
};
